// Added by Sejune Oh on 2020-04-07
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    TableSortLabel as MaterialUITableSortLabel,
    TableSortLabelProps as MaterialUITableSortLabelProps
} from '@material-ui/core'

interface TableSortLabelBaseProps { }
export type TableSortLabelProps = Partial<MaterialUITableSortLabelProps> & TableSortLabelBaseProps

export const TableSortLabel: FC<TableSortLabelProps> = ({ ...props }) => {
    return <MaterialUITableSortLabel {...props}></MaterialUITableSortLabel>
}
